import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import { FormControlLabel, Grid, RadioGroup, withStyles, WithStyles } from '@material-ui/core';

import { styles } from './style';
import { MyPATDialog, MyPATMultiSearch, MyPATSelect, MyPATTextField } from '../../../../common';
import _ from 'lodash';
import * as courseManagementActions from '../../../actions';
import { courseStyles } from '../../../styles';
import { ExistingScheduledTest } from '../../../types/interfaces/ExistingScheduledTest';
import TimeInput from 'material-ui-time-picker';
import MyPATCalendar from '../../../../common/MyPATCalendar';
import { CourseBasicDetails, TestDetail, TestSeriesCoursePlan } from '../../../types/interfaces/CourseBasicDetails';
import courseManagementServices from '../../../service/courseManagementServices';
import { State } from 'react-select/src/Select';
import contentService from '../../../../mylibrary/services/contentService';
import { onlyAllowNumbers } from '../../../../../utils';
interface AddTestPopUpProps extends WithStyles<typeof styles> {
  classes: any;
  open: boolean;
  onClose: Function;
  testDetail: TestDetail;
  fetchScheduleTests: Function;
  fetchMapTestSuggestions: Function;
  fetchCoursesByScheduleId: Function;
  scheduledTests: ExistingScheduledTest[];
  mapTestSuggestions: any;
  coursesByScheduleId: any;
  isEditMode: boolean;
  courseDetails: any[];
  selectedMapTest: any;
  onDone: Function;
  selectedGoalsForTestSeries: any;
  coursePlan: TestSeriesCoursePlan;
  basicDetail:CourseBasicDetails;
  checkMapTestIdExist:Function
}

interface AddTestPopUpState {
  currentTestDetail: TestDetail;
  addTestType: string;
  selectedScheduleTest: any;
  courseData: any;
  mapTestSuggestions: any[];
  selectedMapTestValue: any;
  isMapTestExist: boolean;
  mapTestName: string;
  courseDetail:any;
  mapTestError:string;
  formDataError:any;
  questionsCountFromAPI:boolean;
  durationFromAPI:boolean;
  selectedTestType: string;
  goalsDriller: any;
}

class AddTestPopUp extends React.Component<AddTestPopUpProps, AddTestPopUpState> {
  constructor(props: AddTestPopUpProps) {
    super(props);
    const { testDetail,courseDetails } = this.props;
    const { startDate, endDate, testId } = testDetail;
    this.state = {
      currentTestDetail: this.props.testDetail,
      addTestType: 'existing',
      selectedScheduleTest: {},
      courseData:{} ,
      mapTestSuggestions: [],
      selectedMapTestValue: {},
      isMapTestExist: testId === '000000000000000000000000' ? false : true,
      mapTestName: '',
      courseDetail:{},
      mapTestError:'',
      formDataError:{
        'startDate':{
          errorTxt:"",
        },
        'endDate':{
           errorTxt:''    
        }
      },
      questionsCountFromAPI: false,
      durationFromAPI: false,
      selectedTestType: '',
      goalsDriller: {}
    };
    
  }

  componentDidMount= async () => {
    const { isEditMode, testDetail } = this.props;
    let { isMapTestExist,courseData} = this.state;
    let { currentTestDetail } = this.state;
    let newTestDetail: TestDetail = { ...currentTestDetail };

    const courseId = this.getCourseId();
     courseData={courseId:testDetail.courseId}
     this.setGoalsDriller(courseData.courseId);
     //console.log({courseData});
    if (!isEditMode) {
      if(!_.isEmpty(courseData.courseId)){
         this.getScheduleTest(courseData.courseId);
      }
    } else {
      if (isMapTestExist) {
        const { testId } = testDetail;
        const {questionsCount, duration} = await this.getTestDetailById(testId);
        newTestDetail.questionsCount =  questionsCount;
        newTestDetail.duration = duration.toString();
        
        if(+questionsCount > 0){
          this.setState({
            questionsCountFromAPI: true,
            currentTestDetail: newTestDetail
          })
        }
        if(+duration > 0){
          this.setState({
            durationFromAPI: true,
            currentTestDetail: newTestDetail
          })
        }
      }
    }
    this.setState({courseData});    
  }

  componentDidUpdate(prevProps: AddTestPopUpProps,prevState:AddTestPopUpState) {
    if(_.get(prevState,"courseData.courseId",'')!==_.get(this.state,"courseData.courseId",'')){
      this.setGoalsDriller(this.state.courseData.courseId);
    }
  }

  setGoalsDriller = async (courseId: string) => {
    if(courseId !== ''){
      const res = await courseManagementServices.getCourseDetails(courseId);
      const { courseType, id, groupId, name, targetYear, _id } = res;
      const courseDetail = { courseType, id, groupId, name, targetYear, _id };
      if (res && Object.keys(res).length) {
        const goals = {
          level: 'course',
          course: { courseType, id, groupId, name, targetYear, _id:groupId },
        };
        
        this.setState({
          goalsDriller: {
            ...goals,
          },
          courseDetail
        })
      }
    }
  }

  getTestDetailById = async (testId: string) => {
    const res = await contentService.detailsNTL(`${testId}testpapers`);
    const { title,contentId, content: { data : { questionsCount = 0 } = {} }= {} , duration = 0, contentSubTypeCode} = res;
    
    this.setState({ mapTestName: `${contentId}| ${title}`, selectedTestType: contentSubTypeCode });
    return {questionsCount, duration,contentId}
  };

  getCourseId = () => {
    const { courseDetails } = this.props;
    const courseId = _.map(courseDetails, 'courseId').join(',');
    return courseId;
  };

  getScheduleTest = (courseId: string) => {
    const param = {
      itemType: 'scheduledTests',
      id: courseId,
    };
    this.props.fetchScheduleTests(param);
  };

  getCourseDetailById = async (courseId: string) => {
    const res = await courseManagementServices.getCourseDetails(courseId);
    const { courseType, id, groupId, name, targetYear, _id } = res;
    const courseDetail = { courseType, id, groupId, name, targetYear, _id };
    // courseType: {name: "JEE(A)", id: "5ace20299fe7b01d5806b92d"}
    // id: "5ace20299fe7b01d5806b92d"
    // name: "JEE(A)"
    // groupId: "5ace202e9fe7b01d5806bb6a"
    // name: "JEE(A) - 2016"
    // targetYear: "2016"
    // _id: "5ace202e9fe7b01d5806bb6a"
    this.setState({ courseDetail });
  };

  handleDateChange = (date: any, type: 'startDate' | 'endDate') => {
    const updatedcurrentTestDetail = { ...this.state.currentTestDetail };
    let newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    let newStartDate = new Date(updatedcurrentTestDetail[type] || Date.now());
    // console.log(newStartDate)
    const hours = newStartDate.getHours();
    const minutes = newStartDate.getMinutes();
    const seconds = newStartDate.getSeconds();
    const milliseconds = newStartDate.getMilliseconds();
    newDate.setHours(hours, minutes, seconds, milliseconds);
    updatedcurrentTestDetail[type] = newDate.toISOString();
    this.setState({
      currentTestDetail: updatedcurrentTestDetail,
    });
  };

  removeEndDate(type: string) {
    const updatedcurrentTestDetail = { ...this.state.currentTestDetail };
    updatedcurrentTestDetail.endDate = '';
    this.setState({currentTestDetail: updatedcurrentTestDetail});
  }

  setTestDetialByScheduleTest = async () => {
    let { currentTestDetail, selectedScheduleTest,courseDetail,courseData } = this.state;
    let isMapTestExist=false;
    const minStartDate=_.get(this.props,"basicDetail.startDate.value");
    const minEndDate=_.get(this.props,"basicDetail.endDate.value");

    if (_.isEmpty(selectedScheduleTest)) {
      return;
    } else {
      let newTestDetail: TestDetail = { ...currentTestDetail };
      selectedScheduleTest= JSON.parse(JSON.stringify(selectedScheduleTest));
      //console.log({selectedScheduleTest});
      let {
        paperDetail,
        displayName,
        duration,
        maxAttempt,
        questionsCount,
        blockRevisionTime,
        scheduleDate,
        scheduleEndDate,
        scheduleID,
        testType,
      } = selectedScheduleTest;
      const syllabusText=_.get(paperDetail,"syllabus.text",paperDetail.syllabus);
      let mapTestError='';
      let questionsCountFromAPI, durationFromAPI;
      if(paperDetail.id!=='000000000000000000000000'){
        isMapTestExist=true;
        if(this.props.checkMapTestIdExist(paperDetail.id)){
          mapTestError='Test Id already mapped in the goal';
        }
        const {questionsCount, duration,contentId} = await this.getTestDetailById(paperDetail.id);
        this.checkIfTestExistInGoal(contentId,courseData.courseId);
        questionsCountFromAPI = questionsCount;
        durationFromAPI = duration;
        
        if(+questionsCountFromAPI > 0){
          this.setState({
            questionsCountFromAPI: true,
          })
        }
        if(+durationFromAPI > 0){
          this.setState({
            durationFromAPI: true
          })
        }
      }
      // = questionsCountAndDuration
      // if(!(scheduleDate>=minStartDate&&scheduleDate<=minEndDate)){
      //   scheduleDate=minStartDate;
      // }
      // if(!(scheduleEndDate>=scheduleDate&&scheduleEndDate<=minEndDate)){
      //   scheduleEndDate=''
      // }
      newTestDetail = {
        scheduleID,
        duration: durationFromAPI ? durationFromAPI : duration,
        testId: paperDetail.id,
        revisionTime: blockRevisionTime || '',
        syllabus: syllabusText.replace( /(<([^>]+)>)/ig, ''),
        type: paperDetail.type,
        courseId: newTestDetail.courseId,
        name: displayName,
        endDate: scheduleEndDate||'',
        startDate: scheduleDate,
        maxAttempts: maxAttempt,
        questionsCount: questionsCountFromAPI ? questionsCountFromAPI : questionsCount
      };
      this.setState({ currentTestDetail: newTestDetail,isMapTestExist,mapTestError});
    }
  };
  handleTimeChange = (time: any, type: string) => {
    const updatedcurrentTestDetail = { ...this.state.currentTestDetail };
    const newTime = new Date(time);
    // console.log(newTime);
    const hours = newTime.getHours();
    const minutes = newTime.getMinutes();
    const seconds = newTime.getSeconds();
    const milliseconds = newTime.getMilliseconds();
    let { startDate, endDate } = updatedcurrentTestDetail;
    const minStartDate=_.get(this.props,"basicDetail.startDate.value");
    const minEndDate=_.get(this.props,"basicDetail.endDate.value");
    switch (type) {
      case 'startTime':
        if(_.isEmpty(startDate)){
          startDate=minStartDate
        }
        let tempDate = new Date(startDate);
        tempDate.setHours(hours, minutes, seconds, milliseconds);
        updatedcurrentTestDetail.startDate = tempDate.toISOString();
        //console.log({ tempDate, newTime });
        break;
      case 'endTime':
        if(_.isEmpty(endDate)){
          endDate=minEndDate;
        }
        tempDate = new Date(endDate);
        tempDate.setHours(hours, minutes, seconds, milliseconds);
        updatedcurrentTestDetail.endDate = tempDate.toISOString();
        //console.log({ tempDate, newTime });
        break;
      default:
    }

    this.setState({
      currentTestDetail: updatedcurrentTestDetail,
    });
  };

  handleStartEndDate = () => {
    const { classes } = this.props;
    // const DateVals = ['Start Date & Time', 'End Date & Time'];
    const {currentTestDetail} = this.state;
    const startDate=_.get(currentTestDetail,"startDate","");
    const endDate=_.get(currentTestDetail,"endDate","");
    // console.log({startDate,endDate});
    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();
    const minStartDate=_.get(this.props,"basicDetail.startDate.value");
    const minEndDate=_.get(this.props,"basicDetail.endDate.value");
    const DateVals = [
      {
        label: 'Start Date & Time',
        dateKey: 'startDate',
        timeKey: 'startTime',
      },
      {
        label: 'End Date & Time (optional)',
        dateKey: 'endDate',
        timeKey: 'endTime',
      },
    ];
    // //console.log("Date", DateVals);
    return (
      DateVals.length &&
      DateVals.map((item: { label: string; dateKey: string; timeKey: string }) => (
    <>
    <Grid container justify="space-between" spacing={16}>
       <Grid item xs={6}>
       <InputLabel className={classes.inputLable}>{item.label}</InputLabel>
       {item.label === 'Start Date & Time' && <span className={classes.colorRed}>*</span>}
       {item.label === 'End Date & Time (optional)' && <button className={classes.removeEndDate} disabled={endDate === '' || endDate === null} onClick={() => {this.removeEndDate(item.label)}}>Remove</button>}
          <MyPATCalendar
            fullWidthControl
            onChange={(dateVal: string) =>
              // @ts-ignore
              this.handleDateChange(dateVal, item.dateKey)
            }
            date={item.label === 'Start Date & Time' ? startDate : endDate}
            placeholder={item.label === 'Start Date & Time' ? 'Select Start Date' : 'End Date & Time (optional)'}
            minDate={item.label === 'Start Date & Time' ? minStartDate : startDate}
            maxDate={minEndDate}
            errorText={item.label === 'Start Date & Time' ? startDate ? "Date should be within the course duration":""
                               : endDate ?"Date should be within the course duration and greater than startDate":""}
          />
         </Grid> 
       <Grid item xs={6}> 
       <InputLabel className={classes.inputLable}></InputLabel>
          {
            <div className={classes.customTime}>
            <TimeInput
              mode='12h'
              value={item.label === 'Start Date & Time' ? startDate ? new Date(startDate) : null : 
                         endDate ? new Date(endDate): null}
              onChange={(time: any) => this.handleTimeChange(time, item.timeKey)}
              disable={item.label === 'Start Date & Time' ? _.isEmpty(startDate) : _.isEmpty(endDate)}
              // defaultValue = {new Date()}
              placeholder={
                item.label === 'Start Date & Time'
                  ? (startDate ? null : 'Select Start Time')
                  : (endDate ? null : 'Select End Time')
              }
              disabled={endDate === '' || endDate === null}
            />
            </div>
          }
        </Grid>
    </Grid>  
    </>  
      ))
    );
  };
  handleToggleRadio = (value: string) => {
     const mapTestError='';
    if (value === 'new') {
      this.setState({
        addTestType: value,
        currentTestDetail: this.props.testDetail,
        isMapTestExist:false,
        mapTestError
      });
    } else {
      this.setState({ addTestType: value,mapTestError });
      this.setTestDetialByScheduleTest();
    } 
  };

  renderRadio = () => {
    const { classes } = this.props;
    const { addTestType } = this.state;
    return (
      <div className={classes.root}>
        <Grid container justify='space-between'>
          <RadioGroup
            name='addTestType'
            classes={{
              root: classes.testRadioGroup,
            }}
            className={classes.courseRadioGroup}
            onChange={(_: any, value: string) => this.handleToggleRadio(value)}
            value={addTestType}
          >
            <FormControlLabel
              control={<Radio color='primary' classes={{ root: classes.testRadioRoot }} />}
              label={'Add Existing Scheduled Test'}
              value={'existing'}
            />
            <FormControlLabel
              control={<Radio color='primary' classes={{ root: classes.testRadioRoot }} />}
              value={'new'}
              label={'Schedule New Test'}
            />
          </RadioGroup>
        </Grid>
      </div>
    );
  };

  renderScheduledTestOptions = () => {
    let options: any[] = [];
    const { scheduledTests } = this.props;
    options.push(<option value={''}>{'Select Test'}</option>);
    _.map(scheduledTests, (scheduledTest, index) => {
      const { _id, displayName, scheduleID } = scheduledTest;
      return options.push(
        <option key={index} value={_id}>
          {displayName}
        </option>
      );
    });
    return options;
  };

  renderGoalsOptions = () => {
    let options: any[] = [];
    const { selectedGoalsForTestSeries } = this.props;
    options.push(<option value={''}>{'Select Goal'}</option>);
    _.map(selectedGoalsForTestSeries, (goal, index) => {
      const { courseId, courseName } = goal;
      return options.push(
        <option key={index} value={courseId}>
          {courseName}
        </option>
      );
    });
    return options;
  };

  handleChange = (e: any, data?: any) => {
    const { name, value } = e.target;
    const { scheduledTests, selectedGoalsForTestSeries } = this.props;
    const { currentTestDetail } = this.state;
    let updatedcurrentTestDetail = { ...currentTestDetail };
    switch (name) {
      case 'scheduleTest':
        const selectedItem = scheduledTests.find(({ _id }) => _id === value);
        this.setState({ selectedScheduleTest: selectedItem }, () => this.setTestDetialByScheduleTest());
        break;
      case 'syllabus':
        // if (updatedcurrentTestDetail.syllabus.hasOwnProperty("text"))
        //   updatedcurrentTestDetail.syllabus = value;
        // else
        updatedcurrentTestDetail.syllabus = value;
        
        break;
      case 'selectGoals':
        const filteredCourseData: any = selectedGoalsForTestSeries.filter((goal: any) => goal.courseId === value);
        if(value !== ''){

          this.setState(
            {
              courseData: { ...filteredCourseData[0] },
            },
            () => {
              this.getScheduleTest(filteredCourseData[0] && filteredCourseData[0].courseId);
            }
            );

            this.setGoalsDriller(filteredCourseData[0].courseId);
        }

        break;
      case 'questionsCount':
        updatedcurrentTestDetail.questionsCount = value;
        break;

      default:
        // @ts-ignore
        updatedcurrentTestDetail[name] = value;
    }
    if (name !== 'scheduleTest') {
      this.setState({ currentTestDetail: updatedcurrentTestDetail });
    }
  };
  checkIfTestExistInGoal=async (contentId:string,courseId:string)=>{
      const source="mapTestInCourse";
      let mapTestError='';
      const  apiError= await courseManagementServices.validateMapTestIdBySource({contentId,courseId,source});  
      if(apiError){
          mapTestError=apiError;  
      }
      else if(this.props.checkMapTestIdExist(contentId)){
        mapTestError='Test Id already mapped in the goal';
      }
     this.setState({mapTestError});
  }
  handleTestMapping =(test: any, name: string) => {
    const{courseId,contentId}=test;
    const {courseData}=this.state;
    this.checkIfTestExistInGoal(contentId,courseData.courseId);
    this.setState((prevState: AddTestPopUpState) => {
      const newTestDetail: any = { ...prevState.currentTestDetail };
      newTestDetail.testId = test.content_Id;
      newTestDetail.type=test.contentSubTypeCode;
      newTestDetail.contentId = test.contentId
      return {
        ...prevState,
        selectedMapTestValue: test,
        currentTestDetail: newTestDetail,
      };
    });
  };

  getSearchResult = async (searchQuery: string) => {
    let tests: any[] = [];
    const { courseDetail, goalsDriller } = this.state;
    const { testDetail } = this.props;
    const mainTestTypes = ['full', 'part', 'main','combined','phase'];
    // const contentSubTypeCode = mainTestTypes.includes(testDetail.type) ? testDetail.type : 'phase';
    const contentSubTypeCode=mainTestTypes.join(',');
    if (searchQuery) {
      tests = await courseManagementServices.getTestSuggestions({
        searchText:searchQuery,
        course:courseDetail,
        testType: contentSubTypeCode,
        goalsDriller: {...goalsDriller},
        showAllBucketContent: true,
      });
   const modifiedTests :any=[];
    for(let t of tests){
      const modifiedTestObj={
        ...t,
        displayName:`${t.contentId}| ${t.title}`,
        contentId: t.contentId
       }
      modifiedTests.push(modifiedTestObj);
     }
     //console.log({modifiedTests});
     this.setState({ mapTestSuggestions: modifiedTests });
    }
  };
  handleAddTest = () => {
    const { currentTestDetail,courseData } = this.state;
    currentTestDetail.courseId = courseData.courseId;
    currentTestDetail.type = currentTestDetail.type || 'full';
    this.props.onDone(currentTestDetail);
  };
  checkAddTestBttnDisability = () => {
    const { currentTestDetail,mapTestError, selectedTestType } = this.state;
    const minStartDate=new Date(_.get(this.props,"basicDetail.startDate.value"));
    const minEndDate=new Date(_.get(this.props,"basicDetail.endDate.value"));
    if(mapTestError!='')
     return true;
    const { name, maxAttempts, questionsCount, syllabus, revisionTime, duration, startDate,endDate } = currentTestDetail;
    const testStartDate = new Date(startDate);
    
    if(!(testStartDate>=minStartDate&&testStartDate<=minEndDate)){
      return true
    }
    if (
      name === '' ||
      (selectedTestType === 'phase' && maxAttempts === '') ||
      duration === '' ||
      syllabus === '' ||
      startDate === '' ||
      questionsCount === 0
    )
      return true;
    return false;
  };
  onClose=()=>{
    // event.stopPropagation();
    this.props.onClose()
  }
  render() {
    const { onClose, open, classes, isEditMode } = this.props;
    const {
      addTestType,
      selectedScheduleTest,
      currentTestDetail,
      mapTestSuggestions,
      selectedMapTestValue,
      isMapTestExist,
      mapTestName,
      courseData,
      mapTestError,
      questionsCountFromAPI,
      durationFromAPI
    } = this.state;
    const syllabusText = _.get(currentTestDetail, 'syllabus.text', currentTestDetail.syllabus);
    return (
      <MyPATDialog
        isApplyCustom
        isfixedDialogActions
        dialogOpen={open}
        dialogHasActions={true}
        dialogHeading={isEditMode ? 'Edit Test' : 'Add Test'}
        isAlignCenter={true}
        customButtonVariant='withoutBorderCloseIcon'
        onDialogClose={this.onClose}
        isCustomBackground={false}
        isborderDialogAction={false}
        otherDialogProps={{
          fullWidth: true,
          // maxWidth: 'sm',
        }}
        customDialogActions ={
          <Grid container justify='flex-end' className={classes.mt15}>
          <Button
            variant='contained'
            color='primary'
            className={classes.button}
            onClick={this.handleAddTest}
            disabled={this.checkAddTestBttnDisability()}
          >
            {isEditMode?'Save':'Add Test'}
          </Button>
        </Grid>
        }
      >
        <Grid container direction='row' justify='flex-start' classes={classes.minHeight}>
          {!isEditMode && <Grid style={{ marginBottom: '10px' }}>{this.renderRadio()}</Grid>}
          {
            <div className={classes.division} style={{ width: '100%'}}>
            <Grid className={classes.customSelect}>
              <Typography className={classes.inputLable}>Select Goal</Typography>
              <MyPATSelect
                value={courseData.courseId || ''}
                name='selectGoals'
                onChange={(e: any) => this.handleChange(e)}
                disabled={isEditMode&&isMapTestExist}
              >
                {this.renderGoalsOptions()}
              </MyPATSelect>
            </Grid>
              {!isEditMode && addTestType === 'existing' && (
                <Grid className={classes.customSelect}>
                  <Typography className={classes.inputLable}>Select Existing Scheduled Test</Typography>
                  <MyPATSelect
                    value={selectedScheduleTest._id || ''}
                    name='scheduleTest'
                    onChange={(e: any) => this.handleChange(e)}
                  >
                    {this.renderScheduledTestOptions()}
                  </MyPATSelect>
                </Grid>
              )}
              <Grid className={classes.customInput}>
                <InputLabel className={classes.inputLable}>
                  Test Name<span className={classes.colorRed}>*</span>
                </InputLabel>
                <TextField
                  id='outlined-bare5'
                  fullWidth={true}
                  margin='normal'
                  variant='outlined'
                  name='name'
                  value={currentTestDetail.name}
                  onChange={(e) => this.handleChange(e)}
                />
              </Grid>
              <Grid className={classes.customInput}>
                <InputLabel className={classes.inputLable}>
                  Test Syllabus<span className={classes.colorRed}>*</span>
                </InputLabel>
                <TextField
                  id='outlined-bare0'
                  fullWidth={true}
                  margin='normal'
                  variant='outlined'
                  value={syllabusText}
                  name='syllabus'
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid className={classes.mt10} container justify='space-between' spacing={8}>
                {this.handleStartEndDate()}
              </Grid>
              <Grid className={classes.root}>
                <Grid container spacing={8}>
                  <Grid item xs={6} className={classes.customInput}>
                    <InputLabel className={classes.inputLable}>
                      Duration<span className={classes.colorRed}>*</span>
                    </InputLabel>
                    <MyPATTextField
                      id='outlined-bare1'
                      fullWidth={true}
                      margin='normal'
                      variant='outlined'
                      name='duration'
                      value={currentTestDetail.duration}
                      disabled={durationFromAPI ? true : false}
                      onChange={(e:any) => this.handleChange(e)}
                      onKeyPress={onlyAllowNumbers}
                    />
                  </Grid>
                  <Grid item xs={6} className={classes.customInput}>
                    <InputLabel className={classes.inputLable}>
                      Max Attempt<span className={classes.colorRed}>*</span>
                    </InputLabel>
                    <MyPATTextField
                      id='outlined-bare2'
                      fullWidth={true}
                      margin='normal'
                      variant='outlined'
                      name='maxAttempts'
                      value={currentTestDetail.maxAttempts}
                      onChange={(e:any) => this.handleChange(e)}
                      onKeyPress={onlyAllowNumbers}
                    />
                  </Grid>
                  {/* Questions Count Block */}
                  <Grid item xs={6} className={classes.customInput}>
                    <InputLabel className={classes.inputLable}>
                      Questions Count<span className={classes.colorRed}>*</span>
                    </InputLabel>
                    <MyPATTextField
                      id='outlined-bare2'
                      fullWidth={true}
                      margin='normal'
                      variant='outlined'
                      name='questionsCount'
                      value={currentTestDetail.questionsCount}
                      disabled={questionsCountFromAPI ? true : false }
                      onChange={(e:any) => this.handleChange(e)}
                      onKeyPress={onlyAllowNumbers}
                    />
                  </Grid>
                  <Grid item xs={6} className={classes.customInput}>
                    <InputLabel className={classes.inputLable}>
                      Block Revision Time For This Test
                    </InputLabel>
                    <MyPATTextField
                      fullwidth={true}
                      id='outlined-bare3'
                      fullWidth={true}
                      margin='normal'
                      variant='outlined'
                      name='revisionTime'
                      value={currentTestDetail.revisionTime}
                      onChange={(e:any) => this.handleChange(e)}
                      onKeyPress={onlyAllowNumbers}
                    />
                    <span>(in Days)</span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid className={classes.customInput}>
                <Typography className={classes.inputLable}>
                  Map Test <span> (Optional, can be done later)</span>
                </Typography>
                {isMapTestExist ? (
                  <Grid className={classes.inputCont}>
                  <MyPATTextField 
                    id='outlined-bare'
                    fullWidth={true}
                    margin='normal'
                    variant='outlined'
                    value={mapTestName}
                    disabled={true}
                    isIcon={true}
                    iconLocation={'/assets/svg/test-icon.svg'}
                    error={mapTestError===''?false:true}
                    errorText={mapTestError}
                  />
                  </Grid> 
                ) : (
                <Grid className={classes.transitionCSS}>
                  <Grid className="searchTransition">
                  <MyPATMultiSearch
                    options={mapTestSuggestions}
                    labelKey='displayName'
                    valueKey='content_Id'
                    onChange={this.handleTestMapping}
                    isSearchAble
                    isCustomFilter
                    filtredFunction={this.getSearchResult}
                    name='mapTest'
                    placeholderText='Enter Test Name/ ID to be mapped'
                    value={selectedMapTestValue}
                    error={mapTestError===''?false:true}
                    errorText={mapTestError}
                    disableInput={_.isEmpty(this.state.courseDetail)} 
                  />
                  </Grid>
                </Grid>
                )}
              </Grid>
            </div>
          }
        </Grid>
      </MyPATDialog>
    );
  }
}
// @ts-ignore
// export default withStyles(styles)(AddTestPopUp);

const mapStateToProps = (state: any) => ({
  scheduledTests: state.courseMangementData.courseManagementReducer.scheduledTests,
  mapTestSuggestions: state.courseMangementData.courseManagementReducer.mapTestSuggestions,
  coursesByScheduleId: state.courseMangementData.courseManagementReducer.coursesByScheduleId,
  selectedGoalsForTestSeries: state.courseMangementData.contentManagementData.selectedGoalsForTestSeries,
  basicDetail: state.courseMangementData.courseManagementReducer.testSeries.basicDetail,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchScheduleTests: courseManagementActions.fetchScheduleTests,
      // fetchMapTestSuggestions: courseManagementActions.fetchMapTestSuggestions,
      fetchCoursesByScheduleId: courseManagementActions.fetchCoursesByScheduleID
    },
    dispatch
  );

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(AddTestPopUp)));